<template>
  <vs-tabs
    :position="isSmallerScreen ? 'top' : 'left'"
    class="tabs-shadow-none"
    id="profile-tabs"
    :key="isSmallerScreen"
  >
    <!-- Perfil -->
    <vs-tab icon-pack="feather" icon="icon-user" label="Perfil">
      <div class="mt-4 md:ml-4 md:mt-0">
        <div class="vx-col w-full lg:w-1/1">
          <vx-card title="Atualizar Perfil" class>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Código de Cliente</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <h1>{{user_id}}</h1>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Email</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  type="email"
                  class="w-full"
                  icon-pack="feather"
                  icon="icon-mail"
                  v-model="email"
                  placeholder="Confirme seu e-mail"
                  icon-no-border
                />
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Nova Senha</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  type="password"
                  class="w-full"
                  icon-pack="feather"
                  icon="icon-lock"
                  v-model="password"
                  icon-no-border
                />
                <small>
                  <em>Deixe a senha em branco para manter a mesma senha.</em>
                </small>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Confirmar Nova Senha</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  type="password"
                  class="w-full"
                  icon-pack="feather"
                  icon="icon-lock"
                  v-model="password_confirmation"
                  icon-no-border
                />
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">Código de Segurança</div>
              <div class="vx-col sm:w-2/3 w-full">
                <div><vs-checkbox v-model="email_security_active" :vs-value="true"> Receber um código via e-mail toda vez que eu entrar na minha conta</vs-checkbox></div>
                <div><small>(você não receberá um código se estiver usando autenticação em 2 passos)</small></div>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col sm:w-2/3 w-full ml-auto">
                <vs-button class="mr-3 mb-2" @click="saveProfile">Salvar</vs-button>
                <vs-button color="warning" type="border" class="mb-2" @click="reset">Cancelar</vs-button>
              </div>
            </div>
          </vx-card>
        </div>
      </div>
    </vs-tab>
    <!--
    <vs-tab icon-pack="feather" icon="icon-lock" label="Pagamentos">
      <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
        compras
      </div>
    </vs-tab>
    -->
    <vs-tab icon-pack="feather" icon="icon-info" label="2FA">
      <div class="mt-4 md:ml-4 md:mt-0">
        <div class="vx-col w-full lg:w-1/1">
          <vx-card title="Autenticação usando 2FA" v-show="!twofactor_active && !twofactor.recovery_code">
            <div class="flex flex-col md:flex-row">
              <div class="w-full md:w-8/12">
                <div class="mb-4">
                  Em breve a Autenticação em 2 Passos será obrigatória.<br/>
                  Ative agora e aumente a segurança da sua conta.
                </div>

                <div class="mb-4">Basta seguir o passo-a-passo abaixo.</div>

                <div class="mb-4">
                  <div class="mb-2"><strong>Como ativar o 2FA?</strong></div>

                  <div class="mb-4 ml-6">
                    1. Baixe o aplicativo "Google Authenticator" na loja de aplicativo do seu celular (Google Play ou
                    App Store). Não baixe esse aplicativo no celular monitorado, é só no seu celular.
                  </div>

                  <div class="mb-4 ml-6">
                    2. Abra o aplicativo, clique no símbolo de + e clique em "Ler código de barras" (Scan a barcode).
                  </div>

                  <div class="mb-4 ml-6 md:hidden">
                    3. Agora é só apontar a câmera do seu celular para o QR Code abaixo e em seguida digitar os 6
                    números que apareceram no aplicativo no campo abaixo.
                  </div>

                  <div class="mb-4 ml-6 hidden md:block">
                    3. Agora é só apontar a câmera do seu celular para o QR Code do lado direito e em seguida digitar os
                    6 números que apareceram no aplicativo no campo abaixo.
                  </div>
                </div>

                <div class="mb-4">Caso não consiga ler o QR Code, copie e cole o código abaixo no aplicativo.</div>

                <div class="mb-4 uppercase bg-grey p-4 rounded font-bold text-center">
                  {{ twofactor.secret }}
                </div>

                <div>
                  <vs-input
                    type="text"
                    class="w-full"
                    icon-pack="feather"
                    icon="icon-lock"
                    v-model="twofactor.code"
                    placeholder="Digite aqui o código de 6 dígitos"
                    icon-no-border
                  />
                </div>
              </div>
              <div class="w-full md:w-4/12">
                <div class="flex align-center justify-center">
                  <img :src="twofactor.qrcode"/>
                </div>
              </div>
            </div>

            <div class="mt-4">
              <vs-button @click="checkTwoFactor">Continuar</vs-button>
            </div>
          </vx-card>

          <vx-card title="Autenticação usando 2FA" v-show="twofactor_active">
            <div class="mb-4">A autenticação em 2 passos está ativa na sua conta.</div>

            <div class="mt-4" v-show="twofactor.devices.length">
              <div class="mb-4">Dispositivos confiáveis</div>

              <vs-table :data="twofactor.devices">
                <template slot="thead">
                  <vs-th>Data/Hora Cadastrado</vs-th>
                  <vs-th>Dispositivo Confiável</vs-th>
                  <vs-th>Remover</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr v-for="device in data" :key="device.fingerprint">
                    <vs-td>{{ device.datetime | formatDateTime }}</vs-td>
                    <vs-td>{{ device.name }}</vs-td>
                    <vs-td
                    >
                      <vs-button color="danger" @click="twofactorRemoveTrustedDevice(device.fingerprint)"
                      >Remover
                      </vs-button
                      >
                    </vs-td
                    >
                  </vs-tr>
                </template>
              </vs-table>
            </div>

            <div class="mt-4">
              <vs-button color="danger" @click="removeTwoFactor">Desativar Autenticação em 2 Passos</vs-button>
            </div>
          </vx-card>

          <vx-card title="Autenticação usando 2FA" v-show="twofactor.recovery_code">
            <div class="flex flex-col md:flex-row">
              <div class="w-full md:w-8/12">
                <div class="mb-4">
                  <h3 class="mb-2">Muito Importante!</h3>
                  <div class="mb-2">
                    Anote, copie pra algum lugar, tire um print ou imprima o código de recuperação abaixo e guarde em um
                    local seguro, pois se você perder o seu celular ou o celular for formatado, a única forma de ter
                    acesso à sua conta será usando este código de recuperação.
                  </div>

                  <div>
                    <strong>ATENÇÃO:</strong> Se você perder seu celular e perder o código de recuperação, você nunca
                    mais vai conseguir acessar sua conta. Nem o suporte conseguirá recuperar a conta pra você, então
                    anote ou copie o código abaixo antes de clicar no botão.
                  </div>
                </div>

                <h3 class="mb-4 uppercase bg-success p-4 rounded text-white text-center">
                  <pre>{{ twofactor.recovery_code }}</pre>
                </h3>

                <div class="mt-4">
                  <vs-button @click="saveTwoFactor">Já Salvei o Código</vs-button>
                  <vs-button color="danger" @click="removeTwoFactor" class="ml-4">Cancelar</vs-button>
                </div>
              </div>
            </div>
          </vx-card>
        </div>
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-info" :label="'Atendimento'">
      <div class="mt-4 md:ml-4 md:mt-0">
        <div class="vx-col w-full lg:w-1/1">
          <vx-card :title="`Contatos ${appName}`">
            <div class="user-bio">
              <p>
                Você pode entrar em contato através dos meios abaixo.
                <br/>Nosso horário de atendimento é de Seg-Sex, 9:00 às 18:00 (exceto feriados).
              </p><br/>
              <h6 class="text-danger">Código de Cliente: {{user_id}}</h6>
            </div>

            <div class="mt-5">
              <h6>Telefones:</h6>
              <h5>
                <a :href="`tel:${appTelefoneNaoFormatado}`">
                  <vs-icon icon-pack="fa" icon="fa-phone"></vs-icon>
                  {{ appTelefoneFormatado }}</a>
              </h5>
              <h5>
                <a :href="`https://wa.me/${appTelefoneNaoFormatadoWhatsapp}`" target="_blank">
                  <vs-icon icon-pack="fa" icon="fa-whatsapp"></vs-icon>
                  {{ appTelefoneFormatadoWhatsapp }}
                </a>
              </h5>
            </div>

            <div class="mt-5">
              <h6>Website:</h6>
              <p>
                <a :href="`${appSite}`" target="_blank">{{ appSite }}</a>
              </p>
            </div>

            <div class="social-links flex mt-4">
              <feather-icon
                svgClasses="h-7 w-7 cursor-pointer bg-primary p-1 text-white rounded"
                class="mr-2"
                icon="FacebookIcon"
              ></feather-icon>
              <feather-icon
                svgClasses="h-7 w-7 cursor-pointer bg-primary p-1 text-white rounded"
                class="mr-2"
                icon="YoutubeIcon"
              ></feather-icon>
              <feather-icon
                svgClasses="h-7 w-7 cursor-pointer bg-primary p-1 text-white rounded"
                class="mr-2"
                icon="InstagramIcon"
              ></feather-icon>
            </div>
          </vx-card>
        </div>
      </div>
    </vs-tab>
  </vs-tabs>
</template>

<script>
export default {
  data() {
    return {
      email: '',
      password: '',
      password_confirmation: '',
      twofactor_active: false,
      twofactor: {
        devices: [],
      },
      user_id: '',
      email_security: {devices: [],},
      email_security_active: false,
      appName: process.env.VUE_APP_NAME,
      appTelefoneNaoFormatado: process.env.VUE_APP_TELEFONE_NAO_FORMATADO,
      appTelefoneFormatado: process.env.VUE_APP_TELEFONE_FORMATADO,
      appTelefoneFormatadoWhatsapp: process.env.VUE_APP_TELEFONE_FORMATADO_WHATSAPP,
      appSite: process.env.VUE_APP_SITE,
      appTelefoneNaoFormatadoWhatsapp: process.env.VUE_APP_TELEFONE_NAO_FORMATADO_WHATSAPP,
    };
  },
  computed: {
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768;
    },
  },
  mounted: function () {
    this.load();
  },
  methods: {
    reset: function () {
      this.password = '';
      this.password_confirmation = '';
    },
    load: function () {
      this.$api
      .post('/api/v1/auth/me')
      .then((response) => {
        this.email = response.data.email;
        this.user_id = response.data.user_id;
      })
      .catch((error) => {
        this.$vs.notify({
          time: 6000,
          title: 'Aviso',
          text: Object.values(error.response.data.errors).join('<br>'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
        });
      });

      this.$api
      .get('/api/v1/email-security/load')
      .then((response) => {
        this.email_security = response.data;
        this.email_security_active = response.data.active;
      })
      .catch((error) => {
        this.$vs.notify({
          time: 6000,
          title: 'Aviso',
          text: Object.values(error.response.data.errors).join('<br>'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
        });
      });

      this.$api
      .get('/api/v1/twofactor/load')
      .then((response) => {
        this.twofactor = response.data;
        this.twofactor_active = response.data.active;
      })
      .catch((error) => {
        this.$vs.notify({
          time: 6000,
          title: 'Aviso',
          text: Object.values(error.response.data.errors).join('<br>'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
        });
      });
    },
    saveProfile: function () {
      this.$api
      .patch('/api/v1/auth/update', {
        email: this.email,
        password: this.password,
        password_confirmation: this.password_confirmation,
        email_security_active: this.email_security_active,
      })
      .then(() => {
        this.reset();

        this.$vs.notify({
          time: 6000,
          text: 'Perfil Salvo com Sucesso',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
        });
      })
      .catch((error) => {
        this.$vs.notify({
          time: 6000,
          title: 'Aviso',
          text: Object.values(error.response.data.errors).join('<br>'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
        });
      });
    },
    checkTwoFactor: function () {
      this.$api
      .post('/api/v1/twofactor/check', {
        twofactor: this.twofactor,
      })
      .then((response) => {
        this.twofactor = response.data;
        this.twofactor_active = response.data.active;

        this.$vs.notify({
          time: 6000,
          text: 'Autenticação em 2 Passos - Código Validado com Sucesso',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
        });
      })
      .catch((error) => {
        this.$vs.notify({
          time: 6000,
          title: 'Aviso',
          text: Object.values(error.response.data.errors).join('<br>'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
        });
      });
    },
    saveTwoFactor: function () {
      this.$api
      .post('/api/v1/twofactor/save', {
        twofactor: this.twofactor,
      })
      .then((response) => {
        this.twofactor = response.data;
        this.twofactor_active = response.data.active;

        this.$vs.notify({
          time: 6000,
          text: 'Autenticação em 2 Passos Ativado com Sucesso',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
        });
      })
      .catch((error) => {
        this.$vs.notify({
          time: 6000,
          title: 'Aviso',
          text: Object.values(error.response.data.errors).join('<br>'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
        });
      });
    },
    removeTwoFactor: function () {
      this.$api
      .post('/api/v1/twofactor/remove')
      .then((response) => {
        this.twofactor = response.data;
        this.twofactor_active = response.data.active;

        this.$vs.notify({
          time: 6000,
          text: 'Autenticação em 2 Passos Desativada com Sucesso',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
        });
      })
      .catch((error) => {
        this.$vs.notify({
          time: 6000,
          title: 'Aviso',
          text: Object.values(error.response.data.errors).join('<br>'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
        });
      });
    },
    twofactorRemoveTrustedDevice: function (fingerprint) {
      this.$api
      .delete(`/api/v1/twofactor/remove-device/${fingerprint}`)
      .then((response) => {
        this.twofactor = response.data;
        this.twofactor_active = response.data.active;

        this.$vs.notify({
          time: 6000,
          text: 'Dispositivo Confiável Removido',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
        });
      })
      .catch((error) => {
        this.$vs.notify({
          time: 6000,
          title: 'Aviso',
          text: Object.values(error.response.data.errors).join('<br>'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
        });
      });
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/scss/vuesax/pages/profile.scss';

#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}

.con-slot-tabs {
  width: 100%;
}
</style>
